module.exports = __webpack_public_path__ + "static/media/fingerprint.f9e19a6a.jpg";